// UkiyoInitializer.js
import {useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Ukiyo from 'ukiyojs';

import anime from "animejs";

const UkiyoInitializer = () => {
  const location = useLocation();
  const instancesRef = useRef([]);
  const rafIdRef = useRef(null);

  useLayoutEffect(() => {
    // Cleanup any existing instances and cancel RAF
    if (rafIdRef.current) {
      cancelAnimationFrame(rafIdRef.current);
      rafIdRef.current = null;
    }
    instancesRef.current.forEach(instance => {
      try {
        instance.destroy();
      } catch (error) {
        console.error("Error during instance.destroy:", error);
      }
    });
    instancesRef.current = [];

    // Query for all .ukiyo elements currently in the DOM.
    const elements = document.querySelectorAll('.ukiyo');
    if (!elements.length) {
      console.warn("No .ukiyo elements found in the DOM.");
      return;
    }

    // Initialize Ukiyo on each found element.
    elements.forEach(element => {
      try {
        const instance = new Ukiyo(element, { externalRAF: true, scale: 1.3 });
        instancesRef.current.push(instance);
      } catch (error) {
        console.error("Error initializing Ukiyo for element:", element, error);
      }
    });

    // Create a global RAF loop to update all Ukiyo instances.
    const animate = (time) => {
      instancesRef.current.forEach(instance => {
        try {
          instance.animate();
        } catch (error) {
          console.error("Error during instance.animate:", error);
        }
      });
      rafIdRef.current = requestAnimationFrame(animate);
    };

    rafIdRef.current = requestAnimationFrame(animate);
    
            const elements2 = document.querySelectorAll("[data-background]");
            elements2.forEach((element) => {
                const backgroundImage = element.getAttribute("data-background");
                if (backgroundImage) {
                    element.style.backgroundImage = `url(${backgroundImage})`;
                }
            });
            const elements1 = document.querySelectorAll("[data-bg-color]");
            elements1.forEach((element) => {
                const bgColor = element.getAttribute("data-bg-color");
                if (bgColor) {
                    element.style.backgroundColor = bgColor;
                }
            });
            
            const handleScrollToTop = () => {
                anime({
                    targets: [document.documentElement, document.body], // Both HTML and body for cross-browser compatibility
                    scrollTop: 0, // Scroll to top
                    duration: 2000, // Adjust duration for smoother feel
                    easing: "easeInOutQuad", // Smooth easing effect
                });
            };
    
            // Show/Hide back-to-top button based on scroll position
            const handleScroll = () => {
                const backToTopButton = document.querySelector(".xb-backtotop");
                if (window.scrollY > 500) {
                    backToTopButton?.classList.add("active");
                } else {
                    backToTopButton?.classList.remove("active");
                }
            };
    
            // Attach event listeners
            window.addEventListener("scroll", handleScroll);
            const backToTopButton = document.querySelector(".xb-backtotop");
            backToTopButton?.addEventListener("click", handleScrollToTop);
    
    

    // Cleanup function that will run on unmount or route change.
    return () => {
      if (rafIdRef.current) {
        cancelAnimationFrame(rafIdRef.current);
        rafIdRef.current = null;
      }
      instancesRef.current.forEach(instance => {
        try {
          instance.destroy();
        } catch (error) {
          console.error("Error during instance.destroy:", error);
        }
      });
      instancesRef.current = [];
      window.removeEventListener("scroll", handleScroll);
      backToTopButton?.removeEventListener("click", handleScrollToTop);
    };
    

  }, [location.pathname]); // Re-run effect every time the route changes

  // This component doesn't render any visible UI.
  return null;
};

export default UkiyoInitializer;
